var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"h-full"},[_c('div',{staticClass:"rounded bg-white h-full"},[_c('div',{staticClass:"bg-white cust_card p-2 heading-3 text-red-500"},[_c('p',[_vm._v("FlexPetz.com Sales by Product Category")])])])])])
}]

export { render, staticRenderFns }